import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { paths } from 'src/common/config/TextMessage';

/**
 * CircularProgressWithLabel component displays a circular progress bar with a label.
 *
 * @param {object} props - Component props.
 * @param {number} props.value - The value of the progress indicator (0-100).
 * @returns {JSX.Element} Circular progress bar with a label.
 */
const CircularProgressWithLabel = (props) => {
  const score = Math.round(props.value);

  let colorCode = 'var(--color-error-orange)';
  if (score <= 50) {
    colorCode = 'var(--color-error-orange)'; //red
  } else if (score >= 51 && score <= 65) {
    colorCode = 'var(--color-warning-dark)'; //orange
  } else if (score >= 66 && score <= 75) {
    colorCode = 'var(--color-warning-yellow)'; //yellow
  } else if (score >= 76 && score <= 94) {
    colorCode = 'var(--color-warning-yellow-green)'; //chartreuse
  } else {
    colorCode = 'var(--color-secondary)'; //green
  }
  return (
    <div className="flex items-center space-x-2">
      <Box sx={{ position: 'relative', mt: 0.6 }}>
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            marginRight: 1,
            backgroundColor: colorCode
          }}
        />
      </Box>
      {location.pathname === paths?.scannedPages ? (
        <p
          style={{
            fontFamily: 'Inter',
            fontSize: 'var(--font-size-14)',
            fontWeight: 500,
            lineHeight: 'var(--line-height-20)',
            textAlign: 'left',
            color: 'var(--color-text-near-black)'
          }}
        >
          {' '}
          {`${Math.round(props.value)}`}
        </p>
      ) : (
        <p
          style={{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: 'var(--font-size-14)',
            color: 'var(--color-text-heading)'
          }}
        >
          {' '}
          {`${Math.round(props.value)}%`}
        </p>
      )}
    </div>
  );
};

/**
 * ScoreProgress component displays the progress of a score value.
 *
 * @param {object} props - Component props.
 * @param {number} props.score - The score to display.
 * @returns {JSX.Element} Score progress component.
 */
const ScoreProgress = ({ score }) => {
  const [progress, setProgress] = React.useState(0);
  useEffect(() => {
    setProgress(score > -1 ? score : 0);
  }, [score]);

  return (
    <div>
      {' '}
      <CircularProgressWithLabel value={progress} />
    </div>
  );
};
export default ScoreProgress;
